module.exports = __webpack_public_path__ + "667fb9593cda3547097eaad91bb8b9ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/blow-dryer.png
// module id = 2368
// module chunks = 0